import usePrivateAxios from "@/common/api/usePrivateAxios"
import { getRailsUpdate } from "@/common/utils/getRailsUpdate"
import { mapToDeletion } from "@/common/utils/railsHelpers"
import { EstablishmentLeadsFunnelUpdateValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { EstablishmentLeadData } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type"
import { useMutation } from "@tanstack/react-query"

interface UseUpdateEstablishmentLeadMaintenanceRequiredDocumentsProps {
  id?: string
  establishmentLead: EstablishmentLeadData
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentLeadMaintenanceRequiredDocuments = ({
  id,
  establishmentLead,
  onSuccess,
  onError,
}: UseUpdateEstablishmentLeadMaintenanceRequiredDocumentsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentLeadMaintenanceRequiredDocuments'],
    mutationFn: (data: EstablishmentLeadsFunnelUpdateValidationSchema) => {
      const payload = {
        maintenance_required_documents_attributes: [
          ...getRailsUpdate(
            establishmentLead.maintenance_required_documents || [],
            data.maintenance_required_documents_attributes || [],
            (x) => x.document.id,
            (y) => y.document.id,
            mapToDeletion,
            (z) => ({
              document_id: z.document.id,
              file_attachment_attributes: z.file_attachment_attributes?.blob_id ? {
                blob_id: z.file_attachment_attributes?.blob_id,
              } : undefined,
              valid_until: z.valid_until,
              issue_date: z.issue_date,
            }),
          ),
          ...(data.maintenance_required_documents_attributes?.filter((doc) => doc.id).map((doc) => ({
            id: doc.id,
            file_attachment_attributes: doc.file_attachment_attributes?.blob_id ? {
              blob_id: doc.file_attachment_attributes?.blob_id,
            } : undefined,
            valid_until: doc.valid_until,
            issue_date: doc.issue_date,
          })) || []),
        ],
      }

      return privateAxios.put(`/funnel/establishment/leads/${id}/update_maintenance_models`, {
        lead: payload,
      })
    },
    onSuccess,
    onError,
  })
}
